import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import SessionPage from "./pages/SessionPage";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import { apiClient } from "./api/client";
import "./App.css";

const APP_TOKEN_KEY = "jamroom_app_token";
const AUTH_ERROR_KEY = "jamroom_auth_error";

function App() {
  useEffect(() => {
    // Token bridge: after Access login, the Worker redirects back with `#access_token=...`.
    // We store it in sessionStorage and send it in Authorization headers for all API calls.
    if (typeof window !== "undefined") {
      try {
        const rawHash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
        const hashParams = new URLSearchParams(rawHash);
        const tokenFromHash = hashParams.get("access_token");
        const authErrorFromHash = hashParams.get("auth_error");
        if (tokenFromHash) {
          sessionStorage.setItem(APP_TOKEN_KEY, tokenFromHash);
          hashParams.delete("access_token");
          hashParams.delete("auth_error");
          const newHash = hashParams.toString();
          const newUrl = `${window.location.pathname}${window.location.search}${newHash ? `#${newHash}` : ""}`;
          window.history.replaceState({}, document.title, newUrl);
        }
        if (authErrorFromHash && !tokenFromHash) {
          sessionStorage.setItem(AUTH_ERROR_KEY, authErrorFromHash);
          hashParams.delete("auth_error");
          const newHash = hashParams.toString();
          const newUrl = `${window.location.pathname}${window.location.search}${newHash ? `#${newHash}` : ""}`;
          window.history.replaceState({}, document.title, newUrl);
        }

        const stored = sessionStorage.getItem(APP_TOKEN_KEY);
        apiClient.setAuthToken(stored || null);
      } catch {
        // ignore
      }
    }

    apiClient
      .health()
      .then((status) => {
        console.info("[JamRoom API] health", status);
      })
      .catch((error) => {
        console.warn("[JamRoom API] health check failed", error);
      });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/s/:sessionId" element={<SessionPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
